import { PROG_RESUME_HAS_ERRORED, PROG_RESUME_IS_LOADING, PROG_RESUME_FETCH_DATA_SUCCESS } from '../actions/types';

export function progResumeHasErrored(state = false, action) {
    switch (action.type) {
        case PROG_RESUME_HAS_ERRORED:
            return action.payload;
        default:
            return state;
    }
}
export function progResumeIsLoading(state = false, action) {
    switch (action.type) {
        case PROG_RESUME_IS_LOADING:
            return action.payload;
        default:
            return state;
    }
}
export function progResumeFetch(state = [], action) {

    switch (action.type) {
        case PROG_RESUME_FETCH_DATA_SUCCESS:
            return action.items;
        default:
            return state;
    }
}
